import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import { Layout, Hero, About, Jobs, Featured, Projects, Contact } from '@components';

const StyledMainContainer = styled.main`
  counter-reset: section;
`;

const IndexPage = ({ location }) => (
  <Layout location={location}>
    <Helmet>
      <title>Y Lau - Senior Product Manager | Web3 & Blockchain Expert | Fintech Innovation</title>
      <meta
        name="description"
        content="Senior Product Manager specializing in Web3, blockchain technology, cryptocurrency payments, and fintech innovation. Expert in product strategy, user experience design, and digital transformation with proven track record in mobility and charging ecosystem platforms."
      />
      <meta
        name="keywords"
        content="product manager, senior product manager, web3 product manager, blockchain product manager, cryptocurrency payments, fintech innovation, digital transformation, product strategy, user experience design, mobility solutions, charging ecosystem, OTC trading platform, crypto payment gateway, blockchain technology, DeFi products, product management consultant, tech product leader, startup product manager, agile product development"
      />
      <meta name="author" content="Y Lau" />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      {/* Open Graph tags */}
      <meta
        property="og:title"
        content="Y Lau - Senior Product Manager | Web3 & Blockchain Expert"
      />
      <meta
        property="og:description"
        content="Senior Product Manager specializing in Web3, blockchain technology, cryptocurrency payments, and fintech innovation. Expert in product strategy and digital transformation."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://ylau.dev" />
      <meta property="og:image" content="https://ylau.dev/og-image.png" />
      <meta property="og:site_name" content="Y Lau Portfolio" />

      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Y Lau - Senior Product Manager | Web3 & Blockchain Expert"
      />
      <meta
        name="twitter:description"
        content="Senior Product Manager specializing in Web3, blockchain technology, cryptocurrency payments, and fintech innovation."
      />
      <meta name="twitter:image" content="https://ylau.dev/og-image.png" />
      <meta name="twitter:creator" content="@ylau_dev" />

      {/* Additional SEO tags */}
      <meta name="theme-color" content="#0a192f" />
      <meta name="msapplication-TileColor" content="#0a192f" />
      <link rel="canonical" href="https://ylau.dev" />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Person',
          name: 'Y Lau',
          jobTitle: 'Senior Product Manager',
          description:
            'Senior Product Manager specializing in Web3, blockchain technology, cryptocurrency payments, and fintech innovation',
          url: 'https://ylau.dev',
          image: 'https://ylau.dev/og-image.png',
          sameAs: [
            'https://github.com/ylau',
            'https://linkedin.com/in/ylau',
            'https://twitter.com/ylau_dev',
          ],
          knowsAbout: [
            'Product Management',
            'Web3 Technology',
            'Blockchain',
            'Cryptocurrency',
            'Fintech',
            'Digital Transformation',
            'User Experience Design',
            'Product Strategy',
          ],
          worksFor: {
            '@type': 'Organization',
            name: 'Freelance Product Management Consultant',
          },
        })}
      </script>
    </Helmet>
    <StyledMainContainer className="fillHeight">
      <Hero />
      <About />
      <Jobs />
      <Featured />
      <Projects />
      <Contact />
    </StyledMainContainer>
  </Layout>
);

IndexPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default IndexPage;
